/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import { Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

const DashBoardTopTabBar = () => {
  const navigate = useNavigate();

  return (
    <>
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
        }}
      >
        <a
          onClick={(e: any) => {
            e.preventDefault();
          }}
        >
          <Button
            onClick={() => {
              navigate("/home");
            }}
            sx={{
              color: "#000",
              display: "flex",
              alignItems: "center",
              fontSize: 16,
              marginLeft: 2,
              fontWeight: 600,
            }}
          >
            Home
          </Button>
        </a>

        <Button
          onClick={() => {
            navigate("/dashboard");
          }}
          sx={{
            color: "#000",
            display: "flex",
            alignItems: "center",
            fontSize: 16,
            marginLeft: 2,
            fontWeight: 600,
          }}
        >
          Dashboard
        </Button>

        <Button
          onClick={() => {
            let keysToRemove = [
              "eventDetails",
              "eventVenue",
              "eventSchedule",
              "eventTicketConfig",
              "eventFaq",
            ];
            keysToRemove.map((x) => {
              localStorage.removeItem(x);
            });
            navigate("/dashboard/event/add");
            window.location.reload();
          }}
          sx={{
            color: "#000",
            display: "flex",
            alignItems: "center",
            fontSize: 16,
            marginLeft: 2,
            fontWeight: 600,
          }}
        >
          Create Event
        </Button>
      </Box>
    </>
  );
};

export default DashBoardTopTabBar;
